import {
  ApartmentOutlined,
  DashboardOutlined,
  SafetyCertificateOutlined,
  TeamOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { BaseSidebar } from '@/components/layouts/base-sidebar';
import { getItem, type MenuItem } from '@/components/layouts/sidebar-utils';
import { useProgressRouter } from '@/hooks/use-progress-router';

export function TenantSidebar() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const router = useProgressRouter();

  const mainMenuItems: MenuItem[] = [
    getItem(
      t('navigation.dashboard'),
      '/tenant',
      <DashboardOutlined />,
      undefined,
      {
        onClick: () => router.push('/tenant'),
      },
    ),
    getItem(
      t('navigation.profile'),
      '/tenant/profile',
      <UserOutlined />,
      undefined,
      {
        onClick: () => router.push('/tenant/profile'),
      },
    ),
    getItem(
      t('navigation.organizations'),
      '/tenant/organizations',
      <ApartmentOutlined />,
      undefined,
      { onClick: () => router.push('/tenant/organizations') },
    ),
    getItem(
      t('navigation.users'),
      '/tenant/users',
      <TeamOutlined />,
      undefined,
      {
        onClick: () => router.push('/tenant/users'),
      },
    ),
    getItem(
      t('navigation.roles'),
      '/tenant/roles',
      <SafetyCertificateOutlined />,
      undefined,
      { onClick: () => router.push('/tenant/roles') },
    ),
  ];

  const getSelectedKeys = () => {
    if (pathname.startsWith('/tenant/roles')) {
      return ['/tenant/roles'];
    }
    if (pathname.startsWith('/tenant/users')) {
      return ['/tenant/users'];
    }
    if (pathname.startsWith('/tenant/organizations')) {
      return ['/tenant/organizations'];
    }
    if (pathname.startsWith('/tenant/profile')) {
      return ['/tenant/profile'];
    }
    if (pathname === '/tenant' || pathname === '/tenant/') {
      return ['/tenant'];
    }
    return [pathname];
  };

  return (
    <BaseSidebar menuItems={mainMenuItems} getSelectedKeys={getSelectedKeys} />
  );
}
